import React from "react";
import { CardContent, Typography, Box, Stack, Divider } from "@mui/material";
import { StyledCard } from "../common/StyledComponents";
import NumbersIcon from "@mui/icons-material/Numbers";

const SequenceCard = ({ sequence }) => {
  return (
    <StyledCard>
      <CardContent>
        <Stack direction="row" alignItems="center" spacing={1.5} mb={1}>
          <NumbersIcon />
          <Typography variant="h6" fontWeight="bold">
            {sequence.documentType.replace(/_/g, " ")}
          </Typography>
        </Stack>
        <Divider sx={{ my: 1.5 }} />
        <Box display="flex" justifyContent="space-between" mb={1}>
          <Typography variant="body2" color="text.secondary">
            Prefix
          </Typography>
          <Typography variant="body2" fontWeight="bold">
            {sequence.prefix}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="space-between" mb={1}>
          <Typography variant="body2" color="text.secondary">
            Current Value
          </Typography>
          <Typography variant="body2" fontWeight="bold" color="secondary">
            {sequence.currentValue}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body2" color="text.secondary">
            Branch
          </Typography>
          <Typography variant="body2">{sequence.branchName}</Typography>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default SequenceCard;
